import React, { useEffect, useState } from "react";
import { Button, ScrollView, TextArea } from "devextreme-react";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import notify from "devextreme/ui/notify";
import { confirm } from "devextreme/ui/dialog";

const Insights = (props: any) => {
  const [showCompletebtn, setShowCompletebtn] = useState(false);
  const [enableSave, setEanbleSave] = useState(false);
  const infoInitialState = {
    whatWentWell: "",
    whatNotWentWell: "",
    whatHelped: "",
    whatHindered: "",
    lessonLearnt: "",
    status: "",
  };
  const [infoData, setInfoData] = useState<any>({
    ...infoInitialState,
  });

  useEffect(() => {
    if (props.a3ID) {
      AsyncCallHandler(
        NEXUS_CONST.FETCH_A3_DATA + props.a3ID,
        NEXUS_CONST.GET
      ).then((res) => {
        if (res) {
          setEanbleSave(res?.data?.status === "Complete");
          setInfoData({
            ...infoData,
            whatWentWell: res?.data?.whatWentWell,
            whatNotWentWell: res?.data?.whatNotWentWell,
            whatHelped: res?.data?.whatHelped,
            whatHindered: res?.data?.whatHindered,
            status: res?.data?.status,
            lessonLearnt: res?.data?.lessonLearnt,
          });
          setEanbleSave(res?.data?.status === "Complete");
          setShowCompletebtn(
            props.loggedinUser.toLowerCase() ===
              res.data?.coach.toLowerCase() &&
              res.data?.vsTabs
                ?.filter((item: any) => item.tab !== "9")
                .every((item: any) => item.isSaved) &&
              res?.data?.isCPCompleted
          );
        }
      });
    }
  }, [props.a3ID]);

  const saveA3 = () => {
    if (props.a3ID !== null) {
      let _infoData = { ...infoData };
      let formData = {
        a3ID: props.a3ID,
        tierId: parseInt(props.tierId),
        whatWentWell: _infoData?.whatWentWell?.trim(),
        whatNotWentWell: _infoData?.whatNotWentWell?.trim(),
        whatHelped: _infoData?.whatHelped?.trim(),
        whatHindered: _infoData?.whatHindered?.trim(),
        lessonLearnt: _infoData?.lessonLearnt?.trim(),
        completedOn: props.siteLocalDate,
        lastSaved: "9",
        section:props.activeTab
      };
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_A3_DATA,
        NEXUS_CONST.POST,
        formData
      ).then((res) => {
        if (res) {
          props.isDataSaved(9);
          props.setisOpen("9");
          props.handleA3Save();
          notify(
            {
              message: "Insight Saved suceessfully",
              position: {
                at: "bottom",
                my: "bottom",
              },
            },
            "success",
            500
          );
        }
      });
    }
    props.isDataSaved(9);
    props.setisOpen("9");
    props.handleA3Save();
  };

  const completeA3 = () => {
    let result = confirm(
      "Note : Ensure all containments have been removed, standard work has been written, and employees have been trained to new standard",
      "Are you sure you want to set this excercise to completion?"
    );
    result.then((res) => {
      let _infoData = { ...infoData };
      if (res) {
        let formData = {
          a3ID: props.a3ID,
          tierId: parseInt(props.tierId),
          whatWentWell: _infoData?.whatWentWell?.trim(),
          whatNotWentWell: _infoData?.whatNotWentWell?.trim(),
          whatHelped: _infoData?.whatHelped?.trim(),
          whatHindered: _infoData?.whatHindered?.trim(),
          lessonLearnt: _infoData?.lessonLearnt?.trim(),
          status: "Complete",
          completedOn: props.siteLocalDate,
          lastSaved: "9",
        };
        AsyncCallHandler(
          NEXUS_CONST.MANAGE_A3_DATA,
          NEXUS_CONST.POST,
          formData
        ).then((res) => {
          props.closeShift(false);
          notify(
            {
              message: "A3 Completed suceessfully",
              position: {
                at: "bottom",
                my: "bottom",
              },
            },
            "success",
            500
          );
        });
      }
    });
  };

  const handleValueChange = (e: any) => {
    let name = e.component.option("name");
    let value = e.value;
    if (e.event) {
      setInfoData({ ...infoData, [name]: value });
    }
  };
  return (
    <div>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 9 - &nbsp;</span>Insights & Actions
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "200px", marginTop: "3%" }}
            disabled={enableSave}
            width={200}
            onClick={saveA3}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="420px" className="sps-box-s">
        <TextArea
          id="whatWentWell"
          name="whatWentWell"
          label="What went well?"
          labelMode="floating"
          value={infoData?.whatWentWell}
          onValueChanged={handleValueChange}
          className="dx-field-text"
        ></TextArea>
        <TextArea
          id="whatNotWentWell"
          name="whatNotWentWell"
          label="What didnt go well?"
          labelMode="floating"
          value={infoData?.whatNotWentWell}
          onValueChanged={handleValueChange}
          className="dx-field-text"
        ></TextArea>
        <TextArea
          id="whatHelped"
          name="whatHelped"
          label="What helped?"
          labelMode="floating"
          value={infoData?.whatHelped}
          onValueChanged={handleValueChange}
          className="dx-field-text"
        ></TextArea>
        <TextArea
          id="whatHindered"
          name="whatHindered"
          label="What hindered?"
          labelMode="floating"
          value={infoData?.whatHindered}
          onValueChanged={handleValueChange}
          className="dx-field-text"
        ></TextArea>
        <TextArea
          id="lessonLearnt"
          name="lessonLearnt"
          label="Where can lessons learnt be applied?"
          labelMode="floating"
          value={infoData?.lessonLearnt}
          onValueChanged={handleValueChange}
          className="dx-field-text"
        ></TextArea>
        <div className="sps-save-btn">
          <Button
            style={{ float: "right", width: "200px", marginTop: "3%" }}
            text="Complete"
            onClick={completeA3}
            disabled={infoData.status === "Complete"}
            width={200}
            visible={showCompletebtn}
            type="normal"
          />
        </div>
      </ScrollView>
    </div>
  );
};

export default Insights;
